<template>
  <div :class="{ filter: true, active: opened }">
    <div class="cover" v-if="opened" @click="opened = false"></div>
    <div class="title" @click="opened = !opened">{{ label }}</div>
    <div class="results" v-if="opened">
      <div
        v-for="t in sortedTags"
        :class="{
          suggestion: true,
          category: t.type === 'category',
          year: category === 'year',
          verylarge:
            valueCounts &&
            valueCounts[t.value] > 1000 * (category === 'year' ? 5 : 1),
          large:
            !valueCounts ||
            (valueCounts &&
              valueCounts[t.value] > 200 * (category === 'year' ? 5 : 1)),
          medium:
            valueCounts &&
            valueCounts[t.value] > 50 * (category === 'year' ? 5 : 1),
          small:
            valueCounts &&
            valueCounts[t.value] > 10 * (category === 'year' ? 5 : 1),
          verysmall: valueCounts
        }"
        :key="t.value"
        @click="addTag(t)"
      >
        <span>{{ t.value }}</span>
      </div>
    </div>
    <div
      class="remove"
      v-if="index >= 0 && opened && label !== ''"
      @click="removeTag"
    >
      <div>— remove</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TagList",
  data() {
    return {
      opened: false
    };
  },
  methods: {
    addTag(tag) {
      if (tag.type !== "tag") return;
      if (this.index < 0) {
        this.opened = false;
        this.$store.dispatch("addFilter", {
          category: this.category,
          value: tag.value,
          invert: this.invert
        });
        this.$emit("changed");
      } else {
        this.opened = false;
        this.$store.dispatch("replaceFilter", {
          category: this.category,
          value: tag.value,
          index: this.index,
          invert: this.invert
        });
        this.$emit("changed");
      }
    },
    removeTag() {
      this.opened = false;
      this.$store.dispatch("removeFilter", this.index);
    }
  },
  props: {
    category: String,
    label: String,
    values: Array,
    categorize: Boolean,
    valueCounts: null,
    index: Number,
    invert: Boolean
  },
  computed: {
    sortedTags() {
      let sorted = this.values.slice();
      sorted.sort();

      let categorized = [];
      let alpha = "";

      for (let i = 0; i < sorted.length; i++) {
        if (sorted[i][0].toUpperCase() !== alpha) {
          alpha = sorted[i][0].toUpperCase();
          if (this.categorize)
            categorized.push({ type: "category", value: alpha });
        }
        categorized.push({ type: "tag", value: sorted[i] });
      }

      return categorized;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.cover {
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100vh;
  width: 100vw;
  z-index: 10;
}

.filter {
  position: relative;
  cursor: pointer;
  margin-top: 5px;

  @media (max-width: 815px) and (orientation: landscape) {
    margin-top: 3px;
  }
}

.title {
  font-size: 16px;
  height: 24px;
  border-radius: 0px;
  -webkit-appearance: none;
  padding: 0.25em;
  border: 0;
  border-bottom: 1px solid black;
  padding-right: 0.25em;
  z-index: 11;
  font-weight: 500;
}

.filter.active .title,
.title:hover {
  background-color: $light-gold;
}

.results {
  border-bottom: 1px solid black;
  background-color: $white;
  position: absolute;
  width: 100%;
  min-width: 150px;
  z-index: 1000;
  font-size: 14px;
  max-height: 313px;
  overflow: scroll;
  z-index: 12;
  overflow-x: hidden;

  .suggestion {
    cursor: pointer;
    text-align: left;
    padding: 0.25em 0em;
    padding-right: 10px;
    padding-left: 13px;

    &.verysmall {
      // color: $brown-grey;
      border-left: 1px solid $light-gold;
      padding-left: 12px;
    }

    &.small {
      border-left: 3px solid $light-gold;
      padding-left: 10px;

      // color: #555;
    }

    &.medium {
      // color: $med-gray;
      border-left: 5px solid $light-gold;
      padding-left: 8px;
    }

    &.large {
      // color: black;
      border-left: 7px solid $light-gold;
      padding-left: 6px;
    }

    &.verylarge {
      // font-weight: 500;
      border-left: 10px solid $light-gold;
      padding-left: 3px;
    }

    // &.year {
    //   border-left: 0px;
    //   padding-left: 10px;
    // }

    &:hover {
      border-left-color: $copper;
    }

    &.category {
      font-weight: 600;
      color: black;
      cursor: default;
      border-left-width: 0px;

      &:hover {
        background-color: inherit;
      }
    }

    &:hover {
      background-color: $light-gold;
    }

    span.value {
      font-weight: 500;
    }
  }
}

.remove {
  position: absolute;
  top: 289px;
  background-color: $copper;
  color: $white;
  width: 100%;
  min-width: 150px;
  padding: 0.5em 0.5em;
  text-align: left;
  font-size: 14px;
  z-index: 1000;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    color: $light-gold;
  }
}
</style>
